import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=2aeea9a5&scoped=true&"
import script from "./customerInformation.vue?vue&type=script&lang=js&"
export * from "./customerInformation.vue?vue&type=script&lang=js&"
import style0 from "./customerInformation.vue?vue&type=style&index=0&id=2aeea9a5&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeea9a5",
  null
  
)

export default component.exports